import { SystemService } from './services/system.service';
import { Component, OnInit } from '@angular/core';
import { AuthService } from './services/auth.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { VersionCheckService } from './shared/version-check.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'vmadmin';
  constructor(public authService:AuthService, router: Router, systemService: SystemService, private versionCheck: VersionCheckService){

    // systemService.setRouter(router)

    
}
  ngOnInit() {
    this.versionCheck.start();
    // this.systemService.setRoute(this.route);
  }


}
